/**
 * This file was AUTO GENERATED by [msw-auto-mock](https://github.com/zoubingwu/msw-auto-mock)
 * It has now been manually edited to better match the mocking requirements.
 */

import { HttpResponse, http } from "msw"

import { mockSites, mockMaps, mockDatasets } from './db'

const baseURL = import.meta.env.VITE_MOCK_API_URL

export const handlers = [
  http.get(`${baseURL}/user`, async () => {
    const dummyUser = {
      id: 'd403121d-afac-47b7-bec3-b876a6659ad3',
      name: 'John Doe',
      email: 'johndoe@portphillip.vic.gov.au',
      type: 'site_user',
    }

    return HttpResponse.json(dummyUser, { status: 200 })
  }),
  http.get(`${baseURL}/login`, async ({ request }) => {
    const siteName = request.headers.get('X-Pozi-Sitename')?.toLowerCase()
    const identityProviders = siteName === 'frankston' ? ['entra'] : ['cognito', 'entra']

    return HttpResponse.json({ identity_providers: identityProviders }, { status: 200 })
  }),
  http.get(`${baseURL}/login/:identityProvider`, async ({ params }) => {
    const identityProvider = params.identityProvider
    // This isn't a real login URL, it's just a placeholder for the mock data
    const loginUrl = `http://auth.pozi.com/login/${identityProvider}`

    return HttpResponse.json({ login_url: loginUrl }, { status: 200 })
  }),
  http.get(`${baseURL}/site-details`, async ({ request }) => {
    const siteName = request.headers.get('X-Pozi-Sitename')?.toLowerCase()

    // Check if siteName is a key in mockSites, if not return a 404 error
    if (!mockSites[siteName]) {
      return HttpResponse.json({
        err_code: 404,
        err_desc: `Site '${siteName}' not found`,
      }, { status: 404 })
    }

    return HttpResponse.json(mockSites[siteName], { status: 200 })
  }),
  http.get(`${baseURL}/maps`, async ({ request }) => {
    const siteName = request.headers.get('X-Pozi-Sitename')?.toLowerCase()
    const result = mockMaps[siteName] || mockMaps.council

    return HttpResponse.json(result, { status: result.status })
  }),
  http.get(`${baseURL}/maps/:mapName`, async ({ request, params }) => {
    const siteName = request.headers.get('X-Pozi-Sitename')?.toLowerCase()
    const result = getGetMapResponse(siteName, params.mapName)

    return HttpResponse.json(result.data, {
      status: result.status,
      headers: result.headers || {}
    })
  }),
  http.get(`${baseURL}/maps/:mapName/datasets`, async ({ request, params }) => {
    const siteName = request.headers.get('X-Pozi-Sitename')?.toLowerCase()
    const result = getMapDatasetsResponse(siteName, params.mapName)

    return HttpResponse.json(result.data, { status: result.status })
  }),
]

const getGetMapResponse = (siteName, mapName) => {
  if ((siteName === 'junee' || siteName === 'frankston' || siteName === 'gleneira') && mapName === 'enterprise') {
    return {
      status: 401,
      data: {
        err_code: 401,
        err_desc: `Unauthorized`,
      }
    }
  }

  if (mapName === 'fatalerror') {
    return {
      status: 500,
      data: {}
    }
  }

  if (mapName === 'nonfatalerror') {
    return {
      status: 500,
      data: {
        err_code: 500,
        err_desc: 'Internal Server Error',
      },
      headers: {
        'x-event-id': '1234567890',
      },
    }
  }

  // Check if siteName exists as a key in mockMaps, if not use mockMaps.council
  const siteMaps = mockMaps[siteName] || mockMaps.council

  // Find the map with the specified mapName
  const map = siteMaps.maps.find((m) => m.name === mapName)

  if (!map) {
    // If mapName doesn't exist, return 404 error
    return {
      status: 404,
      data: {
        err_code: 404,
        err_desc: `Map '${mapName}' not found for site '${siteName}'`,
      },
    }
  }

  // Return the found map with 200 status
  return {
    status: 200,
    data: map,
  }
}

const getMapDatasetsResponse = (siteName, mapName) => {
  // Check if siteName exists as a key in mockMaps, if not use 'council' for the siteName
  const resolvedSiteName = mockMaps[siteName] ? siteName : 'council'

  // Check if mockDatasets exists with this siteName and mapName
  const mapdatasets = mockDatasets[resolvedSiteName]?.[mapName]?.mapdatasets

  if (!mapdatasets) {
    // If the datasets don't exist, return 404 error
    return {
      status: 404,
      data: {
        err_code: 404,
        err_desc: `Datasets for map '${mapName}' not found for site '${resolvedSiteName}'`,
      },
    }
  }

  // Return the found datasets with 200 status
  return {
    status: 200,
    data: { mapdatasets },
  }
}
